import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";

function LogoutButton() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      logout();
      localStorage.clear();
      console.log("User logged out");
      navigate("/login");
    } catch (error) {
      console.error("Logout Error:", error);
    }
  };

  return (
    <Button className="button-logout nav-link" onClick={handleLogout}>
      Одјави се
    </Button>
  );
}

export default LogoutButton;
